import React, { useEffect, useReducer, useContext, createContext } from 'react';
import { Row, Col, Skeleton } from 'antd';
import TutorCard from 'components/TutorCard';
import reducer, { TutorCardsState } from './reducer';
import {
  requestSearchTutors,
  TutorCardsActionType,
  TutorsPayload
} from './actions';

interface TutorCardsProps {
  subject?: string;
  level?: string;
  limit: number;
}

export default function TutorCardsBlock({
  subject,
  level,
  limit
}: TutorCardsProps) {
  const [{ tutors, loading }, dispatch] = useReducer(
    reducer,
    useContext(
      createContext({
        loading: false,
        tutors: [],
        totalCount: 0
      })
    )
  ) as [
    TutorCardsState,
    React.Dispatch<{
      type: TutorCardsActionType;
      payload: TutorsPayload | null;
    }>
  ];

  useEffect(() => {
    requestSearchTutors(
      dispatch,
      subject ? subject : 'maths',
      level ? level : 'gcse-igcse',
      limit
    );
  }, [dispatch, limit, subject, level]);

  return (
    <>
      <div style={{ padding: '25px' }}>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ flexWrap: 'wrap' }}
        >
          {loading ? (
            <>
              <Col lg={18} xs={18}>
                <Skeleton active avatar paragraph={{ rows: 2 }} />
                <Skeleton active avatar paragraph={{ rows: 2 }} />
              </Col>
            </>
          ) : (
            tutors.map(tutor => (
              <Col lg={18} xs={18} key={tutor.id}>
                <TutorCard locationDescription="Online" tutor={tutor} />
              </Col>
            ))
          )}
        </Row>
      </div>
    </>
  );
}
